import { render, staticRenderFns } from "./matter-info.vue?vue&type=template&id=8205849e&scoped=true"
import script from "./matter-info.vue?vue&type=script&lang=js"
export * from "./matter-info.vue?vue&type=script&lang=js"
import style0 from "./matter-info.vue?vue&type=style&index=0&id=8205849e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8205849e",
  null
  
)

export default component.exports